import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import { fade } from 'styles/animations'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.neutral.primary};
    box-shadow: 0px 2px 4px 0px #0000001a;
    padding: 0 ${theme.spacings.xlarge};
    height: ${theme.sizes.navbar};
    display: flex;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: ${theme.layers.menu};
    position: fixed;

    ${fade(1)}

    ${media.lessThan('large')`
      padding: 0 ${theme.spacings.small};
    `}

    ${media.lessThan('medium')`
      display: none;
    `}
  `}
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
`

export const LogoWrapper = styled.a`
  position: relative;

  svg {
    height: 48px;
    width: auto;
  }
`

export const MenuNav = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
`

export const MenuLink = styled(AnchorLink)`
  ${({ theme }) => css`
    color: ${theme.colors.grayscale.nav};
    font-size: ${theme.font.sizes.medium};
    font-family: ${theme.font.family};
    font-weight: ${theme.font.regular};
    position: relative;
    outline: none;
    cursor: pointer;

    margin-left: 28px;
    margin-right: 28px;

    &::after {
      background-color: ${theme.colors.primary.main};
      border-radius: 1px;
      border-radius: 1px;
      content: '';
      position: absolute;
      width: 0;
      height: 4px;
      left: 50%;
      bottom: -8px;
      transform: translateX(-50%);
      transition: width 0.25s ease;
    }

    &:hover,
    &:focus {
      &::after {
        width: 100%;
      }
    }

    ${media.lessThan('large')`
      font-size: 15px;

      &:not(:last-child) {
        margin-right: ${theme.spacings.small};
      }
    `}

    ${media.lessThan('1000px')`
      font-size: 14px;

      &:not(:last-child) {
        margin-right: ${theme.spacings.xsmall};
      }
    `}
  `}
`

export const LanguageWrapper = styled.div`
  width: 88px;
`

export const LanguageButton = styled.button`
  ${({ theme, active }) => css`
    color: ${active
      ? theme.colors.grayscale.enabled
      : theme.colors.grayscale.disabled};
    font-size: ${theme.font.sizes.medium};
    font-family: ${theme.font.family};
    font-weight: ${theme.font.bold};
    position: relative;
    outline: none;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 20px;
    }

    &::after {
      background-color: ${theme.colors.primary.main};
      border-radius: 1px;
      border-radius: 1px;
      content: '';
      position: absolute;
      width: 0;
      height: 4px;
      left: 50%;
      bottom: -8px;
      transform: translateX(-50%);
      transition: width 0.25s ease;
    }

    &:hover,
    &:focus {
      &::after {
        width: 100%;
      }
    }

    ${media.lessThan('large')`
      font-size: 15px;

      &:not(:last-child) {
        margin-right: ${theme.spacings.small};
      }
    `}

    ${media.lessThan('1000px')`
      font-size: 14px;

      &:not(:last-child) {
        margin-right: ${theme.spacings.xsmall};
      }
    `}
  `}
`

export const SpaceTrick = styled.span`
  ${media.lessThan('large')`
    display: none;
  `}
`

export const Button = styled.button`
  ${({ theme }) => css`
    background-color: transparent;
    height: 48px;
    width: 160px;
    color: ${theme.colors.grayscale.light.info};
    font-family: ${theme.font.family};
    font-weight: ${theme.font.black};
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    transition: color 350ms ease, border 350ms ease, background-color 350ms ease;
    border: 2px solid ${theme.colors.grayscale.light.info};

    &:hover {
      background-color: ${theme.colors.primary.main};
      border: 2px solid ${theme.colors.primary.main};
      color: white;
    }
  `}
`

export const Link = styled.a`
  position: absolute;
  width: 100%;
  height: 100%;
`